module.exports = __webpack_public_path__ + "static/media/maestro.e17eea00.png";